import { render, staticRenderFns } from "./Tariff.vue?vue&type=template&id=06396af8&scoped=true"
import script from "./Tariff.vue?vue&type=script&lang=js"
export * from "./Tariff.vue?vue&type=script&lang=js"
import style0 from "./Tariff.vue?vue&type=style&index=0&id=06396af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06396af8",
  null
  
)

export default component.exports